import React from 'react';
import Seo from '../components/Seo';
import { Link } from 'react-router-dom';
import { ShoppingBag, ArrowLeft } from 'lucide-react';

const PaymentCancel = () => (
  <div className="min-h-screen ember-texture flex items-center justify-center px-6 py-32">
    <Seo title="Checkout Canceled" path="/payment/cancel" noindex />
    <div className="card-dark rounded-3xl p-10 md:p-14 max-w-lg w-full text-center">
      <ShoppingBag className="w-14 h-14 text-fire-gold mx-auto mb-6" strokeWidth={1.3} />
      <span className="font-marcellus tracking-[0.25em] text-fire-gold text-xs">CHECKOUT CANCELLED</span>
      <h1 className="font-display text-4xl text-fire-cream mt-3 mb-3">Your bag is still here.</h1>
      <p className="text-fire-cream/65 font-body mb-8">
        No worries — nothing was charged. Your items are waiting whenever you’re ready.
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link to="/shop" className="btn-gold rounded-full px-7 py-3.5 font-semibold inline-flex items-center gap-2 text-sm">
          <ArrowLeft className="w-4 h-4" /> Return to Shop
        </Link>
        <Link to="/" className="btn-outline-gold rounded-full px-7 py-3.5 font-semibold text-sm">Back Home</Link>
      </div>
    </div>
  </div>
);

export default PaymentCancel;
